import { render, staticRenderFns } from "./HistoricalDataReport.vue?vue&type=template&id=375d353e&"
import script from "./HistoricalDataReport.vue?vue&type=script&lang=js&"
export * from "./HistoricalDataReport.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalDataReport.vue?vue&type=style&index=0&id=375d353e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports